// extracted by mini-css-extract-plugin
export default {"purchaseBtn":"PayhereCheckoutForm_purchaseBtn__Gaduh"};